import { useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";
import { SnackSnsColor } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";
import type { SnackBlocksFormModelMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods";

import FacebookIcon from "@/components/ui/icon/sns/facebook";
import LineIcon from "@/components/ui/icon/sns/line";
import XIcon from "@/components/ui/icon/sns/x";

type Props = {
	colorType: SnackSnsColor;

	selectedSnsColor: ForAutoGenerator<SnackSnsColor, ""> | undefined;
	onSetSnackSnsColorToSNSColor: SnackBlocksFormModelMethodsType["SNSMethods"]["onSetSnackSnsColorToSNSColor"];
};

export const SNSColorSelect = ({ colorType, selectedSnsColor, onSetSnackSnsColorToSNSColor }: Props) => {
	const colorTypeText = colorType === SnackSnsColor.White ? "ホワイト" : "ブラック";

	const onClick = useCallback(() => {
		onSetSnackSnsColorToSNSColor(colorType);
	}, [colorType, onSetSnackSnsColorToSNSColor]);

	return (
		<div className="space-y-1">
			<p>{colorTypeText}</p>
			<button
				className={cn(
					// 共通のスタイル
					"flex gap-x-6 rounded border-[3px] border-zinc-200 p-4 hover:opacity-80", //
					// ブラックのスタイル
					colorType === SnackSnsColor.Black && "",
					// ホワイトのスタイル
					colorType === SnackSnsColor.White && "border-zinc-200 bg-zinc-400 text-white",
					// 選択されている場合
					selectedSnsColor === colorType && "border-zinc-950",
				)}
				onClick={onClick}
			>
				<XIcon size="lg" />
				<FacebookIcon size="lg" />
				<LineIcon size="lg" />
			</button>
		</div>
	);
};

SNSColorSelect.displayName = "SNSColorSelect";
